import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './poppins.css'
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import store, { persistor } from './rdxsga/store';
import { PersistGate } from 'redux-persist/integration/react';

import 'react-toastify/dist/ReactToastify.css';
import 'react-quill/dist/quill.snow.css';
import 'react-calendar/dist/Calendar.css';
import { ChatSocketProvider } from './context/ChatSocketProvider';


// for default timezone
import moment from 'moment';
import 'moment-timezone'
import { NotificationSocketProvider } from './context/NotificationSocketProvider';
moment.tz.setDefault('Europe/London');



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <NotificationSocketProvider>
        <ChatSocketProvider>
          <App />
        </ChatSocketProvider>
      </NotificationSocketProvider>
    </PersistGate>
  </Provider>

);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(//console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
